import { loadable } from 'system/loadableUtils';

// eslint-disable-next-line import/prefer-default-export
export const Document = loadable(() => import('app/unregistered/pages/document'));
export const RevokedNotice = loadable(() => import('../client/pages/document/RevokedNotice'));
export const WebformsError = loadable(() => import('../client/pages/document/WebformsError'));
